export const MIDDLE_MILE = 'MIDDLE_MILE'
export const FIRST_MILE = 'FIRST_MILE'
export const BACKHAUL = 'BACKHAUL'
export const PICKUP_APPOINTMENT = 'PICKUP_APPOINTMENT'
